import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled from 'styled-components';
import { colors } from '../tokens';
export var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return _extends({}, theme.checkbox.wrapper);
});
export var CheckContainer = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return _extends({}, theme.checkbox.container);
});
export var Check = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border: 1.5px solid ", ";\n  border-color: ", ";\n\n  :hover {\n    border-color: ", ";\n  }\n\n  ", "\n"])), colors.grey[300], function (_ref3) {
  var hasError = _ref3.hasError;
  return hasError ? colors.error : colors.grey[300];
}, function (_ref4) {
  var hasError = _ref4.hasError;
  return hasError ? colors.error : colors.brand.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return _extends({}, theme.checkbox.check);
});
export var Input = styled.input(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &[type='checkbox'] {\n    display: none;\n  }\n\n  &:checked + ", " {\n    background-color: ", ";\n    border: ", ";\n  }\n\n  ", "\n"])), Check, colors.brand.primary, colors.brand.primary, function (_ref6) {
  var theme = _ref6.theme;
  return _extends({}, theme.checkbox.input);
});
export var Text = styled.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  color: ", ";\n\n  :hover {\n    border-color: ", ";\n  }\n\n  ", "\n"])), colors.dark, function (_ref7) {
  var hasError = _ref7.hasError;
  return hasError ? colors.error : colors.dark;
}, function (_ref8) {
  var hasError = _ref8.hasError;
  return hasError ? colors.error : colors.brand.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return _extends({}, theme.checkbox.label);
});